import { Room, TrackEvent } from "@domain";
import { BasePeerCommand } from "./BasePeerCommand";

export class TrackCommand extends BasePeerCommand {
  public execute(e: CustomEvent<TrackEvent>): void {
    const room = this.getRoom();
    const event = e.detail;
    const remoteParticipant = room.remoteParticipants.getParticipantByRemoteId(
      event.peer.userRemoteId
    );
    if (remoteParticipant === null) {
      console.warn("Remote participant not found");
      return;
    }
    if (remoteParticipant.stream === null) {
      console.warn("Remote participant stream is null");
      return;
    }
    event.track.onmute = (e) => console.log("TrackCommand: onmute", e);
    remoteParticipant.stream.addTrack(event.track);
    console.log("TrackCommand: added track to stream", event);
    this.bloc.changeState({
      ...this.bloc.state,
      room: Room.createFromRoom(room)
    });
  }
}
